import React from "react";
import { useTranslation } from "utilities/i18n";

/**
 * Provide a general-purpose cancel button that is guaranteed to not submit its parent form,
 * in addition to being semantically correct. Most often used in modals.
 *
 * This was created to aggregate variants, reduce errors and verbosity with cancel button
 * implementations. Without this, most cancel buttons were incidentally submitting their containing form.
 *
 * This also allows an isolated testing environment, instead of separate tests required for each
 * form. In all prior implementation cases, cancel was not being tested properly.
 *
 * @param props
 * @constructor
 */
export const CancelButton: React.FC<React.ButtonHTMLAttributes<
  HTMLButtonElement
>> = props => {
  const { t } = useTranslation();
  const onClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    // not strictly necessary due to `type="button"`, but additional safety measure
    e.preventDefault();

    if (props.onClick) {
      props.onClick(e);
    }
  };
  return (
    <button
      type="button"
      className={["btn", props.className].filter(c => !!c).join(" ")}
      disabled={props.disabled || false}
      data-testid="cancel"
      name="cancel"
      onClick={onClick}
    >
      {props.children || t("CANCEL")}
    </button>
  );
};
